import { getParentScrollElement } from './getParentScrollElement.mjs';
import { isBrowser } from './envChecker/index.mjs';

function getDocumentScrollElement(element) {
  return isBrowser() ? getParentScrollElement(element) || document.scrollingElement || document.documentElement : null;
}

export { getDocumentScrollElement };
